function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitingPicture1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-line-drawing--picture1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "250px",
    height: "180px",
    viewBox: "0 0 250 180",
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 250 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "svg-line-drawing__line",
    d: "M4,179c-1.7,0-3-1.4-3-3V4c0-1.7,1.3-3,3-3h242c1.6,0,3,1.3,3,3v172c0,1.6-1.4,3-3,3H4z",
    style: {
      strokeDasharray: 846.8409423828125,
      strokeDashoffset: 846.8409423828125
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-line-drawing__line",
    d: "M5,175.8l75-84.9c1.1-1.2,2.9-1.3,4.1-0.1l28.6,30.1c1.1,1.2,3,1.2,4.1,0l62.5-66.4c1.1-1.2,3-1.2,4.2,0l61.9,63.1",
    style: {
      strokeDasharray: 348.2950134277344,
      strokeDashoffset: 348.2950134277344
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-line-drawing__line",
    d: "M71.2,51.1c8.1-3.9,13.4-0.1,13.2,7.2c0,1.2-1.1,3.7-4.7,3.7s-44.6,0-46.2,0c-4.9,0-5-4.5-4.9-5.5c0.6-5.3,3.7-12.4,15.9-12.1C44.8,28.6,74.8,32.3,71.2,51.1z",
    style: {
      strokeDasharray: 145.7947998046875,
      strokeDashoffset: 145.7947998046875
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-line-drawing__line",
    d: "M198.5,69.9c0.5-1.3,1-2.5,1.3-3.9c0.8-3,1.3-6.1,1.3-9.4c0-19.3-15.6-34.9-34.9-34.9s-34.9,15.6-34.9,34.9c0,3.4,0.5,6.6,1.4,9.7c2.5,8.8,8.4,16.1,16.2,20.5",
    style: {
      strokeDasharray: 159.94937133789062,
      strokeDashoffset: 159.94937133789062
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-line-drawing__line",
    d: "M192.8,174l-1.2-12.6c0,0-7.1,7.9-21.6,4.3c0,0,9.6-4.2,12.6-12c0,0-2.1,3.6-12,1.5c6.3-4.8,11.3-10.5,13.8-17.4c-3.9,2.1-8.3,4.5-11.6,1.8c10.2-9.3,12.9-18,15-33.1c0,0,10.2,20.4,17.7,24.9c-5.7,3-9.3,2.4-9.3,2.4s5.7,10.2,18.6,12.9c-3.9,3.3-7.2,4.8-13.2,2.4c0,0,2.4,8.4,15.6,8.4c-12.9,4.8-19,3.2-19,3.2l1.5,13.5",
    style: {
      strokeDasharray: 268.4021911621094,
      strokeDashoffset: 268.4021911621094
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingPicture1);
export default __webpack_public_path__ + "static/media/WaitingPicture1.ba0749ded2642d62a4f8bfabd9765ce9.svg";
export { ForwardRef as ReactComponent };